import React, { Component } from 'react'
import FooterComp from './FooterComp'

export class Footer extends Component {
  render() {
    return (
      <div>
        <FooterComp/>
      </div>
    )
  }
}

export default Footer